import React from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Box
} from '@mui/material';

// Helper to hide columns on mobile (show only on md and up)
const hiddenOnMobile = { display: { xs: 'none', md: 'table-cell' } };

/**
 * Component for campaign table header
 */
const CampaignTableHeader = ({
  isSubid3View,
  sortField,
  sortDirection,
  handleSortChange
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            display: isSubid3View ? 'none' : 'table-cell',
            width: { xs: 'auto', md: '25%' }
          }}
        >
          {isSubid3View ? 'Name' : 'Name'}
        </TableCell>

        {/* Campaign ID column - removed, copy button is next to name */}

        <TableCell align="right"
          onClick={() => handleSortChange('clicks')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          Clicks
          {sortField === 'clicks' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        {/* Visits and Traffic Lost columns removed - always 0 */}
        <TableCell align="right"
          onClick={() => handleSortChange('fb_ctr')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          CTR
          {sortField === 'fb_ctr' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('ctr')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          CVR
          {sortField === 'ctr' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('demand_clicks')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          Conv
          {sortField === 'demand_clicks' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('cost')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText'
          }}
        >
          Cost
          {sortField === 'cost' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('revenue')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText'
          }}
        >
          Rev
          {sortField === 'revenue' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('payout')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          EPC
          {sortField === 'payout' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('cpc')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          CPC
          {sortField === 'cpc' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('roas')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText'
          }}
        >
          ROAS
          {sortField === 'roas' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          onClick={() => handleSortChange('profit')}
          sx={{
            cursor: 'pointer',
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            ...hiddenOnMobile
          }}
        >
          Profit
          {sortField === 'profit' && (
            <Box component="span" sx={{ ml: 0.5 }}>
              {sortDirection === 'asc' ? '↑' : '↓'}
            </Box>
          )}
        </TableCell>
        <TableCell align="right"
          sx={{
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            display: isSubid3View ? 'none' : { xs: 'none', md: 'table-cell' }
          }}
        >
          Budget
        </TableCell>
        {isSubid3View && (
          <TableCell
            sx={{
              fontWeight: 'bold',
              bgcolor: 'primary.light',
              color: 'primary.contrastText'
            }}
          >
            Blacklist
          </TableCell>
        )}
        <TableCell
          sx={{
            fontWeight: 'bold',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            display: isSubid3View ? 'none' : 'table-cell'
          }}
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default CampaignTableHeader; 